import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-daibanshixiang",
  "use": "icon-daibanshixiang-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-daibanshixiang\"><path d=\"M5.205 10.177h-2.82v.947h2.727c.012-.322.044-.638.093-.947zM2.385 6.5h6.081a4.359 4.359 0 011.627-.407v-.54H2.385V6.5zm-.86 6.285c-.359 0-.508-.15-.508-.508V2.083c0-.358.149-.508.507-.508h9.43c.358 0 .508.15.508.508V6.16c.403.074.58.195.944.356V1.401a.77.77 0 00-.771-.771H.843a.77.77 0 00-.77.77v11.563c0 .426.345.771.77.771h4.879c-.195-.363-.348-.542-.453-.95H1.524zm.86-9.544h7.708v.947H2.385V3.24zm8.092 3.54a4.61 4.61 0 100 9.222 4.61 4.61 0 000-9.221zm.008 8.337a3.703 3.703 0 110-7.406 3.703 3.703 0 010 7.406zm-8.1-7.252v.947h3.391c.154-.336.332-.653.532-.947H2.385zm8.129 3.974V9.697h-.93v3.09h3.089v-.948h-2.159z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/daibanshixiang.svg
// module id = 453
// module chunks = 4